var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "justify-space-between": "", column: "", "fill-height": "" } },
    [
      _c(
        "div",
        [
          _c(
            "v-toolbar",
            { attrs: { flat: "" } },
            [
              _c(
                "v-toolbar-title",
                { staticClass: "text-uppercase font-weight-bold" },
                [_vm._v(" " + _vm._s(_vm.$t("homepage.shoppingCart")) + " ")]
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.close } },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          !_vm.cartProducts.length
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "text-center pa-5" },
                  [
                    _c("v-icon", { staticClass: "empty-cart" }, [
                      _vm._v(" mdi-cart-remove ")
                    ]),
                    _c("div", { staticClass: "py-5" }, [
                      _c(
                        "p",
                        { staticClass: "font-weight-bold text-uppercase" },
                        [_vm._v(" " + _vm._s(_vm.$t("cart.noProducts")) + " ")]
                      )
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.cartProducts.length && _vm.cartProducts[0] !== null
            ? _c(
                "v-list",
                _vm._l(_vm.cartProducts, function(item, index) {
                  return _c(
                    "v-list-item",
                    { key: index },
                    [
                      _c(
                        "v-list-item-avatar",
                        [
                          _c("v-img", {
                            attrs: { src: _vm.getProductImage(item.imageUrl) }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", {
                            staticClass: "font-weight-bold",
                            domProps: { textContent: _vm._s(item.name) }
                          }),
                          _c("v-list-item-subtitle", [
                            _vm._v(" " + _vm._s(item.qty) + " x "),
                            _c("span", { staticClass: "primary--text" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("homepage.currency", {
                                      price: _vm.formatThousands(
                                        item.amountWithVat
                                      )
                                    })
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-action",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", small: "" },
                              on: {
                                click: function($event) {
                                  return _vm.removeFromCart(item)
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-close")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.cartProducts.length
        ? _c(
            "div",
            [
              _c("v-divider", { staticClass: "pb-4" }),
              _vm.user && _vm.user.discount
                ? _c(
                    "p",
                    {
                      staticClass:
                        "d-flex justify-space-between align-center px-4"
                    },
                    [
                      _c("strong", { staticClass: "text-uppercase" }, [
                        _vm._v(_vm._s(_vm.$t("cart.discount")) + ":")
                      ]),
                      _c(
                        "span",
                        {
                          staticClass:
                            "primary--text total-amount font-weight-bold"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("homepage.currency", {
                                  price: _vm.formatThousands(_vm.discount)
                                })
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "p",
                {
                  staticClass: "d-flex justify-space-between align-center px-4"
                },
                [
                  _c("strong", { staticClass: "text-uppercase" }, [
                    _vm._v(_vm._s(_vm.$t("cart.subtotal")) + ":")
                  ]),
                  _vm.user && _vm.discount
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "primary--text total-amount font-weight-bold"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("homepage.currency", {
                                  price: _vm.formatThousands(_vm.totalDiscount)
                                })
                              ) +
                              " "
                          )
                        ]
                      )
                    : _c(
                        "span",
                        {
                          staticClass:
                            "primary--text total-amount font-weight-bold"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("homepage.currency", {
                                  price: _vm.formatThousands(_vm.total)
                                })
                              ) +
                              " "
                          )
                        ]
                      )
                ]
              ),
              _c(
                "p",
                { staticClass: "px-4" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        color: "grey lighten-3",
                        tile: "",
                        depressed: "",
                        block: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/cart")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cart.showCart")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        tile: "",
                        depressed: "",
                        block: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/checkout")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cart.checkout")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }